import VideoHelper from './VideoHelper';

class HTML5VideoHelper {
    /**
     * create html5 video
     * @param container
     * @param videoURL
     * @param controls
     */
    createPlayer(container, videoURL, controls = true) {
        const video = document.createElement('video');

        video.src = videoURL;
        video.controls = controls;
        video.autoplay = true;
        video.muted = true;
        video.loop = !controls;
        container.appendChild(video);

        video.play();
        video.setAttribute('playsinline', 'playsinline');

        video.addEventListener('play', (event) => {
            VideoHelper.stopAll(event.currentTarget);
            const videoElement = event.currentTarget.closest('.video');
            if (videoElement) {
                videoElement.classList.remove('video--loading');
            }
        });
    }

    /**
     * add video to element and start video
     * @param container
     * @param videoURL
     * @param controls
     * @param lightbox
     */
    addAndAutoplayVideo(container, videoURL, controls = true, lightbox = false) {
        if (lightbox) {
            container = document.querySelector(`.${container}`);
        }
        this.createPlayer(container, videoURL, controls);
    }
}

export default HTML5VideoHelper;
